import classNames from 'classnames';
import dayjs from 'dayjs';
import React, { useEffect, useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { useNavigate } from 'react-router-dom';
import useStateRef from 'react-usestateref';
import { useOrderAPI } from '../../apis/order-api';
import { useAnalytics } from '../../utils/setup/analytics-setup';
import { usePageview } from '../../hooks/use-pageview';
import { useStorage } from '../../hooks/use-storage';
import { layoutDefaults } from '../../utils/layout-defaults';
import { parseContainerBackgroundImage } from '../../utils/manager/layout-manager';
import { useOAuthModal } from '../order/oauth-modal';
import { useUpdateProfileModal } from './update-profile-modal';

// const animateLeft = 'animate__animated animate__fadeInTop animate__delay-1s';
// const animateRight = 'animate__animated animate__fadeInRight animate__delay-1s';
// const animateRight = 'animate__animated animate__fadeIn animate__delay-1s';

const animateLeft = '';
const animateRight = '';

function NoBillScreen() {
  const [goingBack, setGoingBack] = useState(false);
  const { menuLayout, user, setUser, setOrders, userSetAtRef } = useStorage();
  const { prepareOAuthModal, showOAuthModal } = useOAuthModal();
  const classes = useStyles(menuLayout);
  const { findSpotOrdersFromRemote } = useOrderAPI();
  const { analyticsPageView } = useAnalytics();
  const showUpdateProfileModal = useUpdateProfileModal();
  const signingInRef = useRef(false);
  const [loadingUserModal, setLoadingUserModal, loadingUserModalRef] =
    useStateRef(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  usePageview('No Bill');

  useEffect(() => {
    async function loadOrders() {
      if (user != null) {
        const response = await findSpotOrdersFromRemote().catch((error) =>
          error.response?.status !== 401 ? null : error
        );

        setOrders(response?.data ?? []);
      }
    }

    loadOrders();
  }, [user]);

  useEffect(() => {
    async function init() {
      if (
        userSetAtRef.current == null ||
        dayjs().diff(userSetAtRef.current, 'seconds') > 5
      ) {
        if (signingInRef.current) return;
        signingInRef.current = true;

        await doLogin();
        signingInRef.current = false;
      }
    }

    if (user == null) {
      init();
    }
  }, [user]);

  const doLogin = async () => {
    if (loadingUserModalRef.current) return;
    setLoadingUserModal(true);

    try {
      await prepareOAuthModal();
      setLoadingUserModal(false);

      const oauthResponse = await showOAuthModal({ showName: false });
      setUser(oauthResponse);
    } catch (error) {
      console.error(error);
    }

    setLoadingUserModal(false);
  };

  const goBack = () => {
    setGoingBack(true);

    setTimeout(() => {
      navigate(-1);
    }, 50);
  };

  async function showProfile() {
    // if (!updating) return;

    // setUpdating(false);
    await showUpdateProfileModal();
    analyticsPageView('Bill');

    // setUpdating(true);
  }

  return (
    <div className={classes.container}>
      <FadeIn className={classes.in}>
        {/* <FadeIn>
                        <Lottie options={lottieOptions} height={150} width={150} />
                    </FadeIn> */}
        <div
          className={classNames(classes.title, animateLeft)}
          style={{ '--animate-delay': '0.5s' }}
        >
          {user ? (
            <>
              <h4>{user.name},</h4>
              <h4>{t('no-bill.no-order-yet')}</h4>
            </>
          ) : (
            <h4>{t('no-bill.without-data')}</h4>
          )}
        </div>
        <div
          className={classNames(classes.description, animateRight)}
          style={{ '--animate-delay': '0.5s' }}
        >
          {user ? (
            <>{t('no-bill.order-now')}</>
          ) : (
            <>{t('no-bill.access-your-account')}</>
          )}
          {/* cardápio<br />cardápio<br />cardápio<br />vcardápio<br />cardápio<br />cardápio<br />cardápio<br />cardápio<br />cardápio<br />cardápio<br />cardápio<br />cardápio<br />cardápio<br />cardápio<br />cardápio<br />cardápio<br />cardápio<br />cardápio<br />cardápio<br />cardápio<br />cardápio<br />cardápio<br />cardápio<br />cardápio<br /> */}
        </div>
      </FadeIn>

      {/* x {user?.name}x */}

      <div className={classNames(classes.fixedContainer, 'd-grid')}>
        {!user && (
          <Button
            className={classNames(
              classes.login,
              'animate__animated animate__fadeInUp animate__faster animate__delay-1s'
            )}
            style={{ '--animate-delay': '0.5s' }}
            onClick={doLogin}
            variant="primary"
            size="md"
            // disabled={loading}
            // block
          >
            {loadingUserModal ? (
              <Spinner animation="border" />
            ) : (
              t('no-bill.button.access-account')
            )}
          </Button>
        )}

        {user && (
          <Button
            className={classNames(
              classes.goback,
              'animate__animated animate__fadeInUp animate__faster animate__delay-1s'
            )}
            style={{ '--animate-delay': '0.2s' }}
            size="md"
            onClick={() => showProfile()}
            variant="secondary"
          >
            {t('no-bill.button.fix-my-name')}
          </Button>
        )}

        <Button
          className={classNames(
            classes.goback,
            'animate__animated animate__fadeInUp animate__faster animate__delay-1s'
          )}
          style={{ '--animate-delay': '0.5s' }}
          onClick={goBack}
          variant={user ? 'primary' : 'secondary'}
          size="md"
          // disabled={loading}
          // block
        >
          {goingBack ? <Spinner animation="border" /> : t('back')}
        </Button>
      </div>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // flexGrow: '1',

    // display: "table",
    // position: "absolute",
    // width: "100%",
    // height: "100%",
    // top: 0,
    // left: 0,
    // padding: 30,
    // zIndex: -1,

    minHeight: '100vh',
    paddingBottom: '10vh',

    fontFamily: (layout) =>
      layout?.text?.default_font ?? layoutDefaults.fontFamily,
    backgroundImage: (layout) => parseContainerBackgroundImage(layout),

    // border: '1px solid white',
  },
  in: {
    // display: "table-cell",
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // verticalAlign: "middle",
    textAlign: 'center',
    // border: "1px solid white",
  },
  login: {
    // margin: 0,
    // marginLeft: layoutDefaults.horizontalMargin + 2,
    // marginRight: layoutDefaults.horizontalMargin + 2,
    // marginBottom: 0,
    // border: "1px solid red",
  },
  goback: {
    // margin: 0,
    // marginLeft: layoutDefaults.horizontalMargin + 2,
    // marginRight: layoutDefaults.horizontalMargin + 2,
    // border: "1px solid red",
  },
  title: {
    whiteSpace: 'pre-line',
    marginBottom: 30,
  },
  description: {
    whiteSpace: 'pre-line',
  },
  fixedContainer: {
    ...layoutDefaults.fixedContainer,
    // border: "1px solid blue",
    // display: "flex",
  },
});

export { NoBillScreen };
